import { serverBus } from '@/main';
import Global from '@/scripts/Global'
import FolderApi from '@/scripts/api/folder.api'
import ChannelApi from '@/scripts/api/channel.api'
import SessionManager from '@/Manager/Session.manager'
import UserApi from '@/scripts/api/user.api';
import { CPUtils } from '@/scripts/Utils'
import VueSignals from '@/scripts/VueSignals';

export default {
    name: 'ChooseFolder',
    data (){
        return {
          channelFactory: SessionManager,
          folders: [],
          showModal: false,
          purpose:'',
          selectedFolderId:'',
          selectedFolderName:'',
          mainSpinner: false,
          overlayType : Global.getGlobalSessionValue(VueSignals.OVERLAY_TYPE),
          errorMessage : '',
          newFolderName: 'New folder',
          selectedNode: '',
          selectedNodeId: '',
          nodes:[],
          chooseFolder: false,
        }
      },
    mounted() {
        UserApi.getNodes().then(res => {
        if(res.data.length > 0){
            this.nodes = res.data
        }
        })
     serverBus.$on(VueSignals.OVERLAY_TYPE, (overlayType) => {
      this.overlayType = overlayType;
     });

     serverBus.$on(VueSignals.SHOW_MODAL, (showModal) => {
      this.showModal = showModal;
     });

    },
  methods: {
    closeModal(){
      this.showModal = false;
    },
    modalCall(){
      this.showModal = true;
    },
    SelectFolder(id, name){
      this.selectedFolderId = id
      this.selectedFolderName = name
    },
    selectNode(node_id){
        let selectedNode = this.nodes.find(currNode => {return currNode.node_id == node_id})
        this.selectedNodeId = selectedNode.node_id
    },
    CreateRootFolder(withStorage = false){
        FolderApi.createRootFolder(this.selectedNodeId, this.newFolderName).then(res=> {
          if(res.data.result){
            this.selectedFolderId = res.data.folder_id
            if(withStorage){
              this.CreateNewStorage()
            }
            this.newFolderId = res.data.folder_id
            this.folders.push({
              "cp_id":this.newFolderId,
              "name": this.newFolderName
            })
            this.folders.sort(function(a, b){
              if(b.name.toLowerCase() < a.name.toLowerCase()){
                return 1
              }
              return -1
            })
            this.channel_cp_id = this.newFolderId
            if(this.withChannel){
              this.CreateChannel()
            }
            CPUtils.scroll(document.querySelector(".modal-body .folder-list"), document.querySelector(".folder-list .active").offsetTop)
          }else if(res.data.reason == "folder_already_exists"){
            this.errorMessage = "Folder already exists"
          }
        })
      },
    MoveChannel(){
      this.mainSpinner = true
      if(!this.chooseFolder){
        this.CreateRootFolder(true)
      }else{
        this.CreateNewStorage()
      }
    },
    CreateNewStorage(){
      //	"deleted" : true inside the DB document is "mandatory"
      ChannelApi.createNewStorage(SessionManager.getActiveChannel().channel_id,
        this.selectedFolderId).then(res => {
        if(typeof res.data != 'undefined'){
            if(!res.data.result){
              if(res.data.reason == "empty_folder_id"){
                this.errorMessage = "Choose node first "
              }

              if(res.data.reason == "channel_already_has_storage"){
                this.errorMessage = "Channel already has storage. "
              }
                this.mainSpinner = false
            }

            if(res.data.channel.channel_id.length > 0){
                this.mainSpinner = false;
                SessionManager.DestroyChannel(SessionManager.getActiveChannel().channel_id)
                // SessionManager.removeChannel(SessionManager.getActiveChannel().channel_id)
                SessionManager.createChannel(res.data.channel)
                SessionManager.setActiveChannelById(res.data.channel.channel_id)
                Global.globalValue(VueSignals.SHOW_MODAL, false)
            }

        }
      })
    }
  }
}
